import { Button } from "./ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { Calendar, ExternalLink, Download } from "lucide-react";
import { BACKEND_URL } from "../App";
import { toast } from "sonner";

/**
 * Botón "Agregar a mi calendario" con 3 opciones:
 *  - Google Calendar (URL universal)
 *  - Outlook Calendar (URL universal)
 *  - Descargar archivo .ics (compatible con iOS, Android, Outlook, etc.)
 */
const AddToCalendarButton = ({ evento, eventoId, variant = "outline", className = "", size = "default", testId = "btn-agregar-calendario" }) => {
  const id = eventoId || evento?.evento_id;
  if (!id) return null;

  const fecha = evento?.fecha;
  const horaInicio = evento?.hora_inicio || "10:00";
  const horaFin = evento?.hora_fin || "23:59";
  const titulo = evento?.nombre || "Evento";
  const ubicacion = evento?.locacion || evento?.ubicacion || "";
  const detalles = `Cliente: ${evento?.cliente_nombre || ""}\nTipo: ${evento?.tipo || ""}`;

  const buildDateTime = (date, time) => {
    if (!date) return null;
    const t = (time || "10:00").replace(":", "");
    return `${date.replace(/-/g, "")}T${t}00`;
  };

  const dtStart = buildDateTime(fecha, horaInicio);
  const dtEnd = buildDateTime(fecha, horaFin);

  const googleUrl = dtStart && dtEnd
    ? `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(titulo)}&dates=${dtStart}/${dtEnd}&details=${encodeURIComponent(detalles)}&location=${encodeURIComponent(ubicacion)}`
    : null;

  // Outlook web (live.com) expects ISO datetime
  const outlookStart = fecha ? `${fecha}T${horaInicio}:00` : null;
  const outlookEnd = fecha ? `${fecha}T${horaFin}:00` : null;
  const outlookUrl = outlookStart && outlookEnd
    ? `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(titulo)}&startdt=${outlookStart}&enddt=${outlookEnd}&body=${encodeURIComponent(detalles)}&location=${encodeURIComponent(ubicacion)}`
    : null;

  const icsUrl = `${BACKEND_URL}/api/eventos/${id}/ics`;

  const handleIcs = () => {
    window.location.href = icsUrl;
    toast.info("Se descargara un archivo de calendario. Abrelo con Google Calendar, Outlook o el calendario de tu celular.");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className={className} data-testid={testId}>
          <Calendar className="w-4 h-4 mr-2" />
          Agregar a mi calendario
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-xs text-stone-500">Elige donde guardar</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem disabled={!googleUrl} onClick={() => googleUrl && window.open(googleUrl, "_blank")} data-testid="cal-google">
          <ExternalLink className="w-4 h-4 mr-2 text-emerald-700" /> Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem disabled={!outlookUrl} onClick={() => outlookUrl && window.open(outlookUrl, "_blank")} data-testid="cal-outlook">
          <ExternalLink className="w-4 h-4 mr-2 text-blue-700" /> Outlook Calendar
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleIcs} data-testid="cal-ics">
          <Download className="w-4 h-4 mr-2 text-stone-700" /> Descargar .ics (iOS / Android)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AddToCalendarButton;
